import { useEffect, useRef, useState } from 'react';
import { useWindowDimensions } from 'src/hooks/useWindowDimensions';

export function useNumVisibleColumns() {
  const firstEventRef = useRef<HTMLDivElement>();
  const windowWidth = useWindowDimensions();

  const [numVisibleColumns, setNumVisibleColumns] = useState(7);

  useEffect(() => {
    if (firstEventRef.current) {
      const calendarDayWidth = firstEventRef.current.offsetWidth;
      const calendarDailyWidth =
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        firstEventRef.current.parentElement!.parentElement!.parentElement!
          .parentElement!.parentElement!.offsetWidth;
      setNumVisibleColumns(Math.floor(calendarDailyWidth / calendarDayWidth));
    }
  }, [firstEventRef, windowWidth]);

  return { numVisibleColumns, firstEventRef };
}
